import { observer } from "mobx-react-lite"

import type { ZapStore } from "@/domains/minimal-pools-zap/zap-store"
import { TokenInputCard } from "@/domains/tokens/components/token-input-card"

interface ZapGettingEstimateProps {
  store: ZapStore
}

export const ZapGettingEstimate = observer(({ store }: ZapGettingEstimateProps) => {
  return (
    <TokenInputCard
      amount={store.displayInputAmount}
      disabled={{ amount: true, percentageButtons: true }}
      token={store.zapToken}
      tokens={[]}
      onTokenAmountChange={() => {}}
      onTokenSelect={() => {}}
      showTokenSelectable={false}
      showTokenSymbol={true}
    />
  )
})
